const TRIP_COOKIE = 'ha-trip-prst';
const STATE_COOKIE = 'ha-state-prst';

export const HAS_DOCUMENT_COOKIE =
    typeof document === 'object' && typeof document.cookie === 'string';


const writeCookie = (name, value) => {
    if (!HAS_DOCUMENT_COOKIE) {
        return;
    }
    const expireTime = new Date();
    expireTime.setTime(expireTime.getTime() + 30 * 24 * 60 * 60 * 1000);
    const cookie = [
        name,
        '=',
        encodeURIComponent(JSON.stringify(value)),
        ';expires=',
        expireTime.toUTCString(),
        '; path=/;'
    ].join('');

    document.cookie = cookie;
};

const readCookie = (cookieValue) => {
    let result = {};
    if (!cookieValue) {
        return result;
    }
    try {
        result = decodeURIComponent(cookieValue);
        result = JSON.parse(result);
    } catch (err) { /* silently swallow error */}
    return result;
};

const deleteCookie = (name) => {
    if (!HAS_DOCUMENT_COOKIE) {
        return;
    }
    document.cookie = [
        name,
        '=; expires=Thu, 01-Jan-1970 00:00:01 GMT; path=/'
    ].join('');
};

const tripDataFromCookie = (state) => {
    const tripCookie = readCookie(state[TRIP_COOKIE]);
    const locationCookie = readCookie(state[STATE_COOKIE]);
    const {arrival, departure, numberOfAdults: adultsCount, numberOfChildren: childrenCount, petIncluded} = tripCookie;
    const {lastSearchUrl: searchUrl, lbsKeywords: location} = locationCookie;
    const tripData = {searchUrl, location, arrival, departure, adultsCount, childrenCount, petIncluded};
    return tripData;
};

const writeCookiesFromTripData = (data) => {
    const {searchUrl, location, arrival, departure, adultsCount, childrenCount, petIncluded} = data || {};
    let tripCookieValue = {
        arrival,
        departure,
        numberOfAdults: adultsCount,
        numberOfChildren: childrenCount,
        petIncluded
    };

    let stateCookieValue = {
        lbsKeywords: location,
        lastSearchUrl: searchUrl

    };
    writeCookie(TRIP_COOKIE, tripCookieValue);
    writeCookie(STATE_COOKIE, stateCookieValue);
};

export default {writeCookie, deleteCookie, readCookie, tripDataFromCookie, writeCookiesFromTripData};



// WEBPACK FOOTER //
// ./src/universal/utils/cookieUtils.js